import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    updateProfile(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put('/user/profile', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
